/*
 * component-sticky-atc-v2.js — reveals the V2 PDP sticky Add-to-Cart bar once
 * the shopper scrolls past the primary .bb-v2__submit button, and keeps its
 * label / availability / title / thumbnail mirrored to the primary buy box.
 *
 * The bar does NOT add to cart itself — its button proxies a click to the
 * primary button, so the existing add-on/variant/cart-drawer flow is reused.
 */
(function () {
  function init() {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar || bar.dataset.stickyInit === '1') return;

    var section = document.querySelector('.mp-v2[data-section-id]') || document;
    var primaryBtn = section.querySelector('.bb-v2__submit[data-atc-button]') || section.querySelector('.bb-v2__submit');
    if (!primaryBtn) return; // no buy box on the page -> nothing to mirror
    bar.dataset.stickyInit = '1';

    var primaryLabel = primaryBtn.querySelector('[data-atc-label]');
    var h1 = document.querySelector('.ph-v2__title');
    var stickyBtn = bar.querySelector('[data-sticky-atc-button]');
    var stickyLabel = bar.querySelector('[data-sticky-atc-label]');
    var stickyTitle = bar.querySelector('[data-sticky-atc-title]');
    var stickyVariant = bar.querySelector('[data-sticky-atc-variant]');
    var stickyThumb = bar.querySelector('[data-sticky-atc-thumb]');

    // The product name (first line) is fixed; only the variant/config line
    // changes. Derive the variant line from the H1 by stripping the model name
    // prefix, mirroring product-header-v2.liquid's h1_title composition.
    var productTitle = ((stickyTitle && stickyTitle.dataset.productTitle) || '').trim();

    function syncTitle() {
      if (!h1 || !stickyVariant) return;
      var full = h1.textContent.trim();
      var variant = full;
      if (productTitle && full.indexOf(productTitle) === 0) {
        variant = full.slice(productTitle.length).replace(/^\s*-\s*/, '').trim();
      }
      stickyVariant.textContent = variant;
    }

    function syncButton() {
      if (primaryLabel && stickyLabel) stickyLabel.textContent = primaryLabel.textContent.trim();
      var disabled = primaryBtn.disabled || primaryBtn.getAttribute('aria-disabled') === 'true';
      stickyBtn.disabled = disabled;
      stickyBtn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    }

    syncTitle();
    syncButton();

    // Mirror later changes: the primary label/disabled are updated in place by
    // component-buy-buttons-v2.js on variant:change / addons:change, and the H1
    // by the configuration picker. Observe both rather than duplicating the
    // price maths here.
    var mo = new MutationObserver(function () {
      syncButton();
      syncTitle();
    });
    if (primaryLabel) mo.observe(primaryLabel, { childList: true, characterData: true, subtree: true });
    mo.observe(primaryBtn, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    if (h1) mo.observe(h1, { childList: true, characterData: true, subtree: true });

    // Swap the thumbnail when the colour/variant changes (best-effort; leaves the
    // server-rendered image in place if the variant carries no featured image).
    document.addEventListener('variant:change', function (e) {
      var variant = e.detail && e.detail.variant;
      var img = variant && variant.featured_image;
      if (img && img.src && stickyThumb) {
        stickyThumb.src = img.src + (img.src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
      }
      syncButton();
      syncTitle();
    });
    document.addEventListener('addons:change', syncButton);
    document.addEventListener('upsell:change', syncButton);

    // The bar's button just triggers the real primary button.
    stickyBtn.addEventListener('click', function () {
      if (stickyBtn.disabled) return;
      primaryBtn.click();
    });

    // Reveal only once the primary button has scrolled ABOVE the viewport (the
    // shopper has passed it), not while it's still below the fold on load.
    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var entry = entries[i];
          var scrolledPast = entry.boundingClientRect.top < 0;
          var show = !entry.isIntersecting && scrolledPast;
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
          // Keep the hidden bar out of the tab order / a11y tree too: an
          // aria-hidden container with focusable children is an a11y violation
          // (Lighthouse aria-hidden-focus). `inert` disables focus + pointer.
          if (show) {
            bar.removeAttribute('inert');
          } else {
            bar.setAttribute('inert', '');
          }
        }
      },
      { threshold: 0 }
    );
    io.observe(primaryBtn);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
